import { axiosInstance } from "@/utils/axiosInstance";
import {
  IApplySortRequest,
  IBuyOfferResponse,
  IFilterAndSortResponse,
  IGetOfferByIdRequest,
  IGetOfferByIdResponse,
  IGetRejectReasonsRequest,
  IMatchResponse,
  IRejectOfferRequest,
  IRejectReasonsResponse,
  IOffer,
  IOffersMatchRequest,
  IOffersRequest,
  IOffersResponse,
  IReadOffersRequest,
} from "./interfaces/offers.interfaces";

export const OffersService = {
  getOffers: async ({
    offset = 0,
    limit = 30,
    authToken,
    radius,
    sort,
    filters,
  }: IOffersRequest): Promise<IOffersResponse> => {
    const body = {
      filters: {
        categories_slugs: [],
        radius: radius,
        only: [],
      },
      sort: sort,
    };

    const res = await axiosInstance({
      method: "POST",
      url: "/seja-um-profissional/api/store/offers/search",
      data: {
        authToken,
        offset,
        limit,
        sort: body.sort,
        filters: filters ? filters : body.filters,
      },
    });

    return res.data as IOffersResponse;
  },

  getMatchOffers: async ({
    profileId,
    limit = 50,
  }: IOffersMatchRequest): Promise<IOffer[]> => {
    const res = await axiosInstance({
      method: "GET",
      url: `/seja-um-profissional/api/store/match-offers?profileId=${profileId}&limit=${limit}`,
      timeout: 50000,
    });

    return res.data;
  },

  readOffers: async ({
    offerId,
    authToken,
  }: IReadOffersRequest): Promise<void> => {
    await axiosInstance({
      headers: {
        Authorization: authToken,
      },
      method: "PUT",
      url: `/seja-um-profissional/api/store/offers/${offerId}/read`,
    });
  },

  getOfferById: async ({
    offerId,
    authToken,
    signal,
  }: IGetOfferByIdRequest): Promise<IGetOfferByIdResponse> => {
    const res = await axiosInstance({
      headers: {
        Authorization: authToken,
      },
      method: "GET",
      url: `/seja-um-profissional/api/store/offers/${offerId}`,
      signal,
    });

    return res.data;
  },

  rejectOffer: async ({
    authToken,
    requestId,
    reason,
    details,
  }: IRejectOfferRequest): Promise<void> => {
    await axiosInstance({
      headers: {
        Authorization: authToken,
      },
      method: "POST",
      url: `/seja-um-profissional/api/store/offers/${requestId}/reject`,
      data: {
        reason,
        ...(details ? { details } : {}),
      },
    });
  },

  getRejectReasons: async ({
    authToken,
  }: IGetRejectReasonsRequest): Promise<IRejectReasonsResponse> => {
    const res = await axiosInstance({
      headers: {
        Authorization: authToken,
      },
      method: "GET",
      url: "/seja-um-profissional/api/store/offers/reject-reasons",
    });

    return res.data;
  },

  getFiltersAndSort: async (
    authToken: string,
  ): Promise<IFilterAndSortResponse> => {
    const res = await axiosInstance({
      headers: {
        Authorization: authToken,
      },
      method: "GET",
      url: "/seja-um-profissional/api/store/offers/filters",
    });

    return res.data;
  },

  applySort: async ({
    sort,
    authToken,
    filters,
    offset = 0,
  }: IApplySortRequest): Promise<IOffersResponse> => {
    const res = await axiosInstance({
      method: "POST",
      url: "/seja-um-profissional/api/store/offers/search",
      data: {
        authToken,
        sort,
        filters,
        offset,
      },
    });

    return res.data;
  },

  buyOffer: async ({
    authToken,
    requestId,
  }: {
    authToken: string;
    requestId: string;
  }): Promise<IBuyOfferResponse> => {
    const res = await axiosInstance({
      headers: {
        Authorization: authToken,
      },
      method: "POST",
      url: `/seja-um-profissional/api/store/offers/${requestId}/accept`,
    });

    return res.data;
  },

  buyOfferWithExclusivity: async ({
    authToken,
    requestId,
  }: {
    authToken: string;
    requestId: string;
  }): Promise<IBuyOfferResponse> => {
    const res = await axiosInstance({
      headers: {
        Authorization: authToken,
      },
      method: "POST",
      url: `/seja-um-profissional/api/store/offers/${requestId}/accept-exclusive`,
    });

    return res.data;
  },
};
